import podcastBackground from "assets/images/podcast-background.png";
import { useModal } from "context/hooks/useModal";
import ReactPlayer from "react-player";

const Poadcast = ({ poadcast }) => {
  const { showModal } = useModal();

  return (
    <div
      className="relative flex flex-col gap-12 justify-center items-center mt-5 h-52 bg-center bg-cover bg-no-repeat rounded-2xl"
      style={{ backgroundImage: `url(${podcastBackground})` }}
    >
      <h2 className="text-white text-2xl font-semibold">A Day In a Life</h2>
      <button
        className="py-3 bg-gradient-to-b from-[#F29423] to-[#B06915] text-white rounded-xl px-8 text-xl font-medium flex items-center justify-center gap-4"
        onClick={() => {
          showModal(<RenderPoadcast url={poadcast} />, "md");
        }}
      >
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 0C18.505 0 18.991 0.190005 19.361 0.533005C19.731 0.877005 19.957 1.34701 19.995 1.85001L20 2V16C20 16.505 19.81 16.991 19.467 17.361C19.123 17.731 18.653 17.957 18.15 17.995L18 18H2C1.495 18 1.00901 17.81 0.639008 17.467C0.269008 17.123 0.0430049 16.653 0.00500488 16.15L0 16V2C0 1.495 0.190005 1.00901 0.533005 0.639008C0.877005 0.269008 1.34701 0.0430049 1.85001 0.00500488L2 0H18ZM18 2H2V16H18V2ZM8.34 4.638L8.858 4.868L9.196 5.028L9.58299 5.218L10.013 5.436L10.483 5.686L10.99 5.966L11.256 6.118L11.774 6.423L12.248 6.715L12.678 6.98801L13.058 7.241L13.538 7.571L13.902 7.834L13.997 7.90401C14.151 8.01901 14.277 8.168 14.363 8.34C14.449 8.512 14.494 8.702 14.494 8.894C14.494 9.086 14.449 9.276 14.363 9.448C14.277 9.62 14.151 9.769 13.997 9.884L13.674 10.119L13.234 10.427L12.878 10.666L12.473 10.929L12.02 11.212L11.521 11.512L10.987 11.821L10.478 12.103L10.007 12.353L9.577 12.573L9.19099 12.761L8.569 13.049L8.339 13.149C8.162 13.225 7.97101 13.259 7.77901 13.248C7.58701 13.236 7.4 13.18 7.233 13.084C7.067 12.988 6.92501 12.854 6.82001 12.694C6.71401 12.533 6.647 12.35 6.625 12.159L6.567 11.594L6.535 11.22L6.493 10.556L6.47 10.048L6.455 9.493L6.451 9.19901L6.44901 8.894C6.44901 8.687 6.451 8.48701 6.455 8.29401L6.47 7.739L6.493 7.23199L6.52 6.77499L6.55 6.37399L6.625 5.63C6.647 5.439 6.714 5.255 6.819 5.095C6.925 4.934 7.067 4.8 7.233 4.703C7.4 4.607 7.58701 4.55099 7.77901 4.53999C7.97101 4.52799 8.163 4.562 8.34 4.638ZM8.951 7.13901L8.515 6.92101L8.48599 7.408L8.464 7.959L8.451 8.569L8.44901 8.894L8.451 9.21899L8.464 9.828L8.474 10.111L8.5 10.631L8.515 10.866L8.94901 10.648L9.436 10.392L9.97099 10.098L10.255 9.936L10.806 9.61L11.3 9.304L11.736 9.024L11.932 8.894L11.525 8.62399L11.059 8.33C10.794 8.166 10.526 8.00601 10.256 7.85001L9.97301 7.689L9.439 7.395L8.951 7.13901Z"
            fill="white"
          />
        </svg>
        Watch
      </button>
    </div>
  );
};
export default Poadcast;

const RenderPoadcast = ({ url }) => {
  const { hideModal } = useModal();

  return (
    <div className="max-h-[90vh] md:max-h-[70vh] overflow-y-auto">
      <button
        className="rounded-full border border-black w-6 h-6 mb-4"
        onClick={hideModal}
      >
        X
      </button>

      <ReactPlayer url={url} className="!w-full" />
    </div>
  );
};
